import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, CreditCardIcon, MailIcon, MapPinIcon, TruckIcon } from 'lucide-react';
const DETAILS = [{
  icon: MapPinIcon,
  label: 'Dirección de envío',
  value: 'Bvar. España 2140, apto 502 · Pocitos, Montevideo, CP 11300'
}, {
  icon: CreditCardIcon,
  label: 'Método de pago',
  value: 'Tarjeta terminada en 4242'
}, {
  icon: TruckIcon,
  label: 'Entrega estimada',
  value: '24 a 48 h en Montevideo · 2 a 4 días al interior'
}, {
  icon: MailIcon,
  label: 'Comprobante',
  value: 'Te enviamos el detalle a ana.zapata@mail.com'
}];
export function Confirmation() {
  return <div className="w-full bg-black" data-id="element-1008" data-mp="1mdpxuu0epqo7">
      <div className="mx-auto w-full max-w-3xl px-5 py-20 lg:py-28" data-id="element-1009" data-mp="1mcoiweg9sk17">
        <div className="text-center" data-id="element-1010" data-mp="2a3269rnwtupg">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-teal-500" data-id="element-1011" data-mp="2a1zab5bqd22o">
            <CheckIcon className="h-8 w-8 text-black" data-id="element-1012" data-mp="2evlhwj31efrm" />
          </div>
          <h1 className="mt-8 font-display text-5xl uppercase leading-none text-white sm:text-6xl" data-id="element-1013" data-mp="3nzykjiw30cg1">
            Pedido confirmado
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-white/50" data-id="element-1014" data-mp="3ixzfm4kp17gz">
            Gracias por tu compra. Tu pedido{' '}
            <strong className="text-white" data-id="element-1015" data-mp="3s0qvqhoikrey">#ZADAR-0043</strong> ya está en
            preparación y lo despachamos en las próximas 24 horas.
          </p>
        </div>

        <dl className="mt-12 grid gap-5 border-y border-white/10 py-10 sm:grid-cols-2" data-id="element-1016" data-mp="am3mwonvxbq5">
          {DETAILS.map(({
          icon: Icon,
          label,
          value
        }) => <div key={label} className="flex items-start gap-3" data-id="element-1017" data-mp="jkyrxxf70frv">
              <Icon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-1018" data-mp="fj3skygtocgq" />
              <div data-id="element-1019" data-mp="fjvbp9t8ghq4">
                <dt className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/45" data-id="element-1020" data-mp="fh979j1n2ic4">
                  {label}
                </dt>
                <dd className="mt-1.5 text-sm leading-relaxed text-white/55" data-id="element-1021" data-mp="2hbi7rprzf2tg">
                  {value}
                </dd>
              </div>
            </div>)}
        </dl>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:justify-center" data-id="element-1022" data-mp="p8dv5vvvuzr0">
          <Link to="/mis-pedidos" className="bg-pink-500 px-8 py-4 text-center text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-pink-600" data-id="element-1023" data-mp="u89z5v4kyr6k">
            Ver mis pedidos
          </Link>
          <Link to="/productos" className="border border-white px-8 py-4 text-center text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-white hover:text-black" data-id="element-1024" data-mp="1385f0d92zacx">
            Seguir comprando
          </Link>
        </div>
      </div>
    </div>;
}